import * as SetPropertyActionOperations from 'automation-ui-action-features/actions/set-property/SetPropertyActionOperations';
import * as PropertyValueTypes from 'automation-ui-flow-core/fields/PropertyValueTypes';
const inferPropertyActionOperationType = setPropertyActionMetadata => {
  switch (setPropertyActionMetadata.getValueType()) {
    case PropertyValueTypes.INCREMENT:
      return SetPropertyActionOperations.INCREASE;
    default:
      return SetPropertyActionOperations.SET;
  }
};
export default inferPropertyActionOperationType;